import React from 'react'
import "./Collection.css"
import{Link}from 'react-router-dom'

function Collection() {

  
  return (
    <div className='content'>
      <h1 className='coll'>Collections</h1>
      <div className='making-row'>
      <p className='line'>Explore curated lists of top restaurants, cafes, pubs, and bars in Ranchi, based on trends</p>
      <p className='collection-link'>All Collection in Ranchi</p>
      </div>

        <div className='con1'>
        <Link style={{textDecoration: 'none'}} to="/foods">
      <div className='cards card1'>
        <h3>Trending This week</h3>
        <p>25 Places</p>
      </div>
      </Link>
      <Link style={{textDecoration: 'none'}} to="/foods">
      <div className='cards card2'>
      <h3>Brillient Biryani</h3>
      <p>9 Places</p>
      </div>
      </Link>
      <Link style={{textDecoration: 'none'}} to="/foods">
      <div className='cards card3'>
      <h3>Greate Cafe</h3>
      <p>7 Places</p>
      </div>
      </Link>
      <Link style={{textDecoration: 'none'}} to="/foods">
      <div className='cards card4'>
      <h3>Outdoor Siting </h3>
      <p>7 Places</p>
      </div>
      </Link>
      </div>


    </div>

  )
}

export default Collection
